// extracted by mini-css-extract-plugin
module.exports = {"Header":"RewardCards_Header__1Igui","HeaderTitle":"RewardCards_HeaderTitle__y9XT_","TabsContainer":"RewardCards_TabsContainer__evbiT"};